// extracted by mini-css-extract-plugin
export var sectorsWrapper = "BrowseSectors-module--sectorsWrapper--RkEC3";
export var hasSameSibling = "BrowseSectors-module--hasSameSibling--ZelI_";
export var sectorListWrapper = "BrowseSectors-module--sectorListWrapper--3PvB5";
export var sectorList = "BrowseSectors-module--sectorList--11HG_";
export var heading = "BrowseSectors-module--heading--2P2zJ";